const products = [
  {
    id: 1,
    name: "Tyre Patch (Bias)",
    images: ["/assets/Tyre_repair_patch.png",
      "/assets/Tyre_Repair_patch_Packaging.png",
      "/assets/Tyre_patch_5No_box_back.png",
      "/assets/Tyre_patch_boxes.png",
      "/assets/Tyre_patch_5No.png"
    ],
    description: "Manufactured with nylon cord fabric, our Bias Tyre Repair Patches are designed for the repair of punctures, cuts, and injuries in bias-ply tyres including passenger cars, trucks, tractors, and small OTR tyres. Suitable for tread, shoulder, and sidewall repairs. Compatible with both hot and cold vulcanizing systems."
  },
  {
    id: 2,
    name: "Radial Patch",
    images: ["/assets/Radial_patch.png"],
    description: "Engineered with polyester cord fabric and a shock-absorbing rubber ply, our Radial Tyre Repair Patches are designed specifically for the structural demands of radial tyres. Suitable for tube-type and tubeless radial tyre repairs, they offer high strength, excellent flexibility, and reliable permanent bonding via chemical vulcanization."
  },
  {
    id: 3,
    name: "Bonding Gum 125°C",
    images: ["/assets/Bonding_gum_125.png",
      "/assets/BondingGum2.png"
    ],
    description: "An uncured rubber compound specifically formulated for hot vulcanizing processes at 125°C. Used in tyre retreading and section repairs, it bonds repair patches and tread rubber permanently to the tyre casing. Once cured, it becomes an integral part of the tyre, delivering strong adhesion, high flexibility, and long-lasting durability."
  },
  {
    id: 4,
    name: "Hot Cushion Gum",
    images: ["/assets/Hot_cushion_gum.png",
      "/assets/Hot_cushion_gum2.png"
    ],
    description: "A thin sheet of uncured rubber compound used as an undertread bonding layer in hot tyre retreading processes. Applied between the buffed tyre casing and the precured tread rubber, it vulcanizes under heat and pressure to form a strong, permanent bond. Features excellent tack, uniform gauge, and good heat and overcure resistance."
  },
  {
    id: 5,
    name: "Submersible Rubber Compound",
    images: ["/assets/Submersible_compound.png",
      "/assets/Submersible_compound2.png"
    ],
    description: "A specially formulated rubber compound designed for use in the manufacturing, installation, and repair of submersible pumps. It creates a waterproof and shockproof joint at cable connections and pump joints, protecting against moisture ingress and electrical hazards. Features excellent tensile strength, high stretchability, and good coverage per roll."
  },
  {
    id: 6,
    name: "Puncture Compound",
    images: ["/assets/Puncture_compound.png",
      "/assets/Puncture_compound2.png"
    ],
    description: "A rubber-based compound used by tyre repair professionals for filling and sealing puncture injuries in tube-type tyres. It provides a reliable seal against air leakage and moisture ingress, and is compatible with both hot and cold vulcanizing repair methods. Suitable for use on motorcycle, car, truck, and agricultural tyres."
  },
  {
    id: 7,
    name: "Insulation Compound (Skim) for Conveyor Belt Repair",
    images: ["/assets/InsulationCompound_skim.png"],
    description: "An uncured rubber skim compound used as an intermediate insulating layer in hot vulcanized conveyor belt splicing and repairs. Applied between the fabric plies, it enhances bonding strength between layers, ensures tensile performance of the splice area, and acts as an adhesive tie gum. Compatible with NN nylon, EP polyester, and steel cord conveyor belts."
  },
  {
    id: 8,
    name: "Cover Compound for Conveyor Belt Repair",
    images: ["/assets/CoverCompoundCB.png"],
    description: "An uncured rubber cover compound used as the outer protective layer in hot vulcanized conveyor belt splices and repairs. It restores the wear and tear resistance of the belt's surface after repair, protecting the belt carcass from abrasion, impact, and environmental damage. Available in multiple thicknesses, suitable for fabric and steel cord conveyor belts used in mining, quarrying, and industrial applications."
  },
];

export default products;